<template>
  <iframe
    :height="data.height"
    :src="data.embed"
    :width="data.width"
    frameborder="0"
    v-if="data.service === 'youtube'"
  />
</template>

<script>
export default {
  name: 'EditorEmbed',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
iframe {
  display: block;
  max-width: 100%;
}
</style>
